<template>
    <CardsListWrapper cardListId="evaluations_list">

        <template v-slot:cardsList>
            <CardEval v-for="(evaluation, index) in evalsList"
                :index="index"
                :key="evaluation.id"
                :evaluation="evaluation"
                @evaluationDeleted="showDeletedNotif"
                @notifSended="showNotif"/>
        </template>

        <template v-slot:cardsListHelpers>
            <transition name="notif-slide-up">
                <alert v-if="showEmailSendedNotif" context="success" @close="showEmailSendedNotif=false">
                    {{ $t('modules.evaluations.index.evalsList.alertSendEval') }}
                </alert>
            </transition>

            <transition name="notif-slide-up">
                <alert v-if="showEvalDeletedNotif" context="success" @close="showEvalDeletedNotif=false">
                    {{ $t('modules.evaluations.index.evalsList.alertDeleteEval') }}
                </alert>
            </transition>

        </template>

    </CardsListWrapper>

</template>

<script>
import AddToPositionModal from './addToPositionModal'

import CardEval from './cardEval'

export default {
    name: 'CardsListEvals',
    components: {
        AddToPositionModal,
        CardEval
    },
    data(){
        return {
            showEmailSendedNotif: false,
            showEvalDeletedNotif: false,
            sortableData: {name: 'created_at', type: 'desc'},
        }
    },
    computed: {
        evalsList(){
            return this.$store.state.EvalStore.evalsList
        }
    },
    methods: {
        showNotif(){
            this.showEmailSendedNotif = true
        },
        showDeletedNotif(){
            this.showEvalDeletedNotif = true
        },
        handleSortData(sortName, sortType){
            const data = {
                sort_column: sortName,
                sort_type: sortType
            }
            this.$store.dispatch('EvalStore/indexEvals', data)
        }
    }
}
</script>